const COLLECTION_TYPES = {
  EVEFS: 'evefs',
  REGIONAL: 'regional',
};
export default COLLECTION_TYPES;
